module.exports = "<router-outlet></router-outlet>\n<app-notifier></app-notifier>"


//////////////////
// WEBPACK FOOTER
// ./src/app/public/public.component.html
// module id = ./src/app/public/public.component.html
// module chunks = main